var __TEMP__ = require('./_assocIndexOf.js');var assocIndexOf = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = listCacheGet;
